// composables/useAuth.js

export default function useAuth() {
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

  return {
    userInfo
  }
}
